export function CMSTopicSection(props) {
  return <div>{props.children}</div>
}
